import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step7View from './Step7-view';
import types from '../../types';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const Step7 = ({
                 submitStep,
                 regType,
                 prevCompletedStepSign,
                 prevCompletedStepSignFalse,
               }) => {
  const {formatMessage} = useIntl();

  const handleSubmit = () => {
    submitStep({
      step: 7,
      data: {regType, prevCompletedStepSign},
    })
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => trackEvent('signup_step',
          {
            step_number: 7,
            step_name_en: 'National insurance',
            step_name_he: formatMessage({id: 'step7.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.error({err}));
  };

  return (
    <Formik
      initialValues={{}}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      <Step7View/>
    </Formik>
  )
};

Step7.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  submitStep: PropTypes.func
};

export default Step7;
